interface Spec {
	name: string;
	role: string;
	subrole: number;
}

interface ItemClasses {
	[key: number]: number[];
}

interface Class {
	name: string;
	color: string;
	itemClasses: ItemClasses;
	specs: Spec[];
}

interface Classes {
	[key: number]: Class;
}

export const classes: Classes = {
	1: {
		name: "Warrior",
		color: "#C79C6E",
		itemClasses: {
			2: [0, 1, 2, 3, 4, 5, 6, 7, 8, 10, 13, 14, 15, 16, 18, 20],
			4: [0, 4, 5, 6, 11, -2, -3, -4, -6]
		},
		specs: [{
			name: "Fury",
			role: "DPS",
			subrole: 1
		}, {
			name: "Arms",
			role: "DPS",
			subrole: 1
		}, {
			name: "Protection",
			role: "TANK",
			subrole: 1
		}]
	},
	2: {
		name: "Paladin",
		color: "#F58CBA",
		itemClasses: {
			2: [0, 1, 4, 5, 6, 7, 8, 14, 20],
			4: [0, 4, 5, 6, 11, -2, -3, -4, -5, -6]
		},
		specs: [{
			name: "Holy",
			role: "HEALING",
			subrole: 1
		}, {
			name: "Protection",
			role: "TANK",
			subrole: 1
		}, {
			name: "Retribution",
			role: "DPS",
			subrole: 1
		}]
	},
	3: {
		name: "Hunter",
		color: "#ABD473",
		itemClasses: {
			2: [0, 1, 2, 3, 6, 7, 8, 10, 13, 14, 15, 18, 20],
			4: [0, 3, 5, 11, -2, -3, -4, -6]
		},
		specs: [{
			name: "Beast Mastery",
			role: "DPS",
			subrole: 2
		}, {
			name: "Marksmanship",
			role: "DPS",
			subrole: 2
		}, {
			name: "Survival",
			role: "DPS",
			subrole: 1
		}]
	},
	4: {
		name: "Rogue",
		color: "#FFF569",
		itemClasses: {
			2: [0, 2, 3, 4, 7, 13, 14, 15, 16, 18, 20],
			4: [0, 2, 5, 11, -2, -3, -4, -6]
		},
		specs: [{
			name: "Assassination",
			role: "DPS",
			subrole: 1
		}, {
			name: "Outlaw",
			role: "DPS",
			subrole: 1
		}, {
			name: "Subtlety",
			role: "DPS",
			subrole: 1
		}]
	},
	5: {
		name: "Priest",
		color: "#FFFFFF",
		itemClasses: {
			2: [4, 10, 14, 15, 19, 20],
			4: [0, 1, 5, 11, -2, -3, -4, -5, -6]
		},
		specs: [{
			name: "Discipline",
			role: "HEALING",
			subrole: 2
		}, {
			name: "Holy",
			role: "HEALING",
			subrole: 2
		}, {
			name: "Shadow",
			role: "DPS",
			subrole: 2
		}]
	},
	6: {
		name: "Death Knight",
		color: "#C41F3B",
		itemClasses: {
			2: [0, 1, 4, 5, 6, 7, 8, 14, 20],
			4: [0, 4, 5, 11, -2, -3, -4, -6]
		},
		specs: [{
			name: "Blood",
			role: "TANK",
			subrole: 1
		}, {
			name: "Frost",
			role: "DPS",
			subrole: 1
		}, {
			name: "Unholy",
			role: "DPS",
			subrole: 1
		}]
	},
	7: {
		name: "Shaman",
		color: "#0070DE",
		itemClasses: {
			2: [0, 1, 4, 5, 10, 13, 14, 15, 20],
			4: [0, 3, 5, 6, 11, -2, -3, -4, -5, -6]
		},
		specs: [{
			name: "Enhancement",
			role: "DPS",
			subrole: 1
		}, {
			name: "Elemental",
			role: "DPS",
			subrole: 2
		}, {
			name: "Restoration",
			role: "HEALING",
			subrole: 2
		}]
	},
	8: {
		name: "Mage",
		color: "#69CCF0",
		itemClasses: {
			2: [7, 10, 14, 15, 19, 20],
			4: [0, 1, 5, 11, -2, -3, -4, -5, -6]
		},
		specs: [{
			name: "Arcane",
			role: "DPS",
			subrole: 2
		}, {
			name: "Fire",
			role: "DPS",
			subrole: 2
		}, {
			name: "Frost",
			role: "DPS",
			subrole: 2
		}]
	},
	9: {
		name: "Warlock",
		color: "#9482C9",
		itemClasses: {
			2: [7, 10, 14, 15, 19, 20],
			4: [0, 1, 5, 11, -2, -3, -4, -5, -6]
		},
		specs: [{
			name: "Affliction",
			role: "DPS",
			subrole: 2
		}, {
			name: "Destruction",
			role: "DPS",
			subrole: 2
		}, {
			name: "Demonology",
			role: "DPS",
			subrole: 2
		}]
	},
	10: {
		name: "Monk",
		color: "#00FF96",
		itemClasses: {
			2: [0, 4, 6, 7, 10, 13, 14, 20],
			4: [0, 2, 5, 11, -2, -3, -4, -5, -6]
		},
		specs: [{
			name: "Brewmaster",
			role: "TANK",
			subrole: 1
		}, {
			name: "Mistweaver",
			role: "HEALING",
			subrole: 1
		}, {
			name: "Windwalker",
			role: "DPS",
			subrole: 1
		}]
	},
	11: {
		name: "Druid",
		color: "#FF7D0A",
		itemClasses: {
			2: [4, 5, 6, 10, 11, 12, 13, 14, 15, 20],
			4: [0, 2, 5, 11, -2, -3, -4, -5, -6]
		},
		specs: [{
			name: "Feral",
			role: "DPS",
			subrole: 1
		}, {
			name: "Guardian",
			role: "TANK",
			subrole: 1
		}, {
			name: "Restoration",
			role: "HEALING",
			subrole: 2
		}, {
			name: "Balance",
			role: "DPS",
			subrole: 2
		}]
	},
	12: {
		name: "Demon Hunter",
		color: "#A330C9",
		itemClasses: {
			2: [0, 7, 9, 13, 14, 20],
			4: [0, 2, 5, 11, -2, -3, -4, -6]
		},
		specs: [{
			name: "Havoc",
			role: "DPS",
			subrole: 1
		}, {
			name: "Vengeance",
			role: "TANK",
			subrole: 1
		}, {
			name: "Devourer",
			role: "DPS",
			subrole: 2
		}]
	},
	13: {
		name: "Evoker",
		color: "#33937F",
		itemClasses: {
			2: [0, 4, 5, 7, 10, 13, 15],
			4: [0, 3, 5, 11, -2, -3, -4, -5, -6]
		},
		specs: [{
			name: "Devastation",
			role: "DPS",
			subrole: 2
		}, {
			name: "Preservation",
			role: "HEALING",
			subrole: 2
		}, {
			name: "Augmentation",
			role: "DPS",
			subrole: 2
		}]
	}
};

export default classes;

